import { hasLowerCase, hasUpperCase, hasNumeric, hasNonAlphanumeric, validateEmail, showInputErrorMessage, hideInputErrorMessage } from "./validationUtils";

$(function () {
  $("input[name='Password']").keyup(function () {
    var password = $(this).val();

    $("#passwordLowercaseLetter").prop("checked", hasLowerCase(password));
    $("#passwordUppercaseLetter").prop("checked", hasUpperCase(password));
    $("#passwordNumericCharacter").prop("checked", hasNumeric(password));
    $("#passwordNonAlphabetic").prop("checked", hasNonAlphanumeric(password));
  });

  $("input[type='email']").keyup(function () {
    var email = $(this).val();

    if (validateEmail(email)) {
      if ($(this).hasClass("error")) {
        $(this).removeClass("error");
        hideInputErrorMessage($(this));
      }
    } else if (!$(this).hasClass("error")) {
      $(this).addClass("error");
      showInputErrorMessage($(this), "Please provide correct email address");
    }
  });
});

if (document.getElementById("password") && document.getElementById("confirmedPassword")) {
  var password = document.getElementById("password");
  var confirmedPassword = document.getElementById("confirmedPassword");

  function validatePassword() {
    if (!isPasswordValid()) {
      password.setCustomValidity("Password is weak");
    } else if (passwordHasSpace()) {
      password.setCustomValidity("Password cannot contain space");
    } else {
      password.setCustomValidity("");
    }
  }

  function validateMismatch() {
    if (password.value !== confirmedPassword.value) {
      confirmedPassword.setCustomValidity("Password doesn't match");
    } else {
      confirmedPassword.setCustomValidity("");
    }
  }
  function passwordHasSpace() {
    return password.value.indexOf(" ") >= 0;
  }
  function isPasswordValid() {
    // return hasLowerCase(password.value) && hasUpperCase(password.value) && hasNumeric(password.value) && hasNonAlphanumeric(password.value) && password.value.length > 9;
    // hasLowerCase(password.value) && hasUpperCase(password.value) && hasNumeric(password.value) && password.value.length > 9;
    return /^.*(?=.{12,})((?=.*[\[\]!@#$%^&*()/\\\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/g.test(password.value);
  }

  password.onchange = validateMismatch;
  confirmedPassword.onkeyup = validateMismatch;
  password.onkeyup = validatePassword;
}

if (document.getElementById("email") && document.getElementById("confirmedEmail")) {
  // CONFIRM EMAIL VALIDATION

  var email = document.getElementById("email");
  var confirmedEmail = document.getElementById("confirmedEmail");
  var oldEmail = "";

  function validateEmails() {
    if (email.value.toLowerCase() !== confirmedEmail.value.toLowerCase()) {
      confirmedEmail.setCustomValidity("Email doesn't match");
    } else {
      confirmedEmail.setCustomValidity("");
    }
  }

  function isEmailChanged() {
    if (oldEmail === "") {
      oldEmail = email.value.toLowerCase();
    } else if (oldEmail.toLowerCase() !== email.value.toLowerCase()) {
      email.setCustomValidity("");
      oldEmail = email.value.toLowerCase();
    }
  }

  email.onkeyup = validateEmails;
  email.onchange = isEmailChanged;
  confirmedEmail.onkeyup = validateEmails;
}

if (document.getElementById("registrationForm")) {
  const form = document.querySelector("#registrationForm");

  const observer = new MutationObserver((mutations, observer) => {
    if (document.querySelector(".input-validation-error")) {
      observer.disconnect();
      handleValidationErrors(form);
    }
  });

  observer.observe(form, { childList: true, subtree: true });

  form.querySelectorAll("input, select, textarea").forEach((field) => {
    field.addEventListener("blur", () => updateClassList(field));
    field.addEventListener("change", () => updateClassList(field));
  });

  function handleValidationErrors(form) {
    const fields = form.querySelectorAll("input, select, textarea");
    fields.forEach(toggleErrorClass);
  }

  function toggleErrorClass(field) {
    if (field.classList.contains("input-validation-error")) {
      field.classList.add("error");
    } else {
      field.classList.remove("error");
    }
  }

  function updateClassList(field) {
    if (field.classList.contains("input-validation-error") && field.value !== "") {
      field.classList.remove("error");
    } else {
      field.classList.add("error");
    }
  }
}
